import { catchError, map, mergeMap, throwError } from "rxjs";
import { Injectable } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class HistorySharedFacade {
  constructor(protected store: Store,
              protected actions$: Actions) {
  }

  //<editor-fold desc="Selectors">

  blockUiType$ = this.store.select(FlatStates.HistoryControlState.blockUiType$);
  canUndo$ = this.store.select(FlatStates.HistoryControlState.canUndo$);
  canRedo$ = this.store.select(FlatStates.HistoryControlState.canRedo$);
  canSave$ = this.store.select(FlatStates.HistoryControlState.canSave$);

  //</editor-fold>

  //<editor-fold desc="Lazy Selectors">

  entityHasSnapshotItems$ = (entity: any) => this.hasSnapshotItems$([entity.id, ...(entity.children || [])]);
  hasSnapshotItems$ = (ids: string[]) => this.store.select(FlatStates.HistoryControlState.hasSnapshotItems$).pipe(map(filterFn => filterFn(ids)));

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_canSave = () => this.store.selectSnapshot(FlatStates.HistoryControlState.canSave$);
  snapshot_canUndo = () => this.store.selectSnapshot(FlatStates.HistoryControlState.canUndo$);
  snapshot_canRedo = () => this.store.selectSnapshot(FlatStates.HistoryControlState.canRedo$);
  snapshot_blockUiType = () => this.store.selectSnapshot(FlatStates.HistoryControlState.blockUiType$);

  //</editor-fold>

  //<editor-fold desc="Actions">

  ofActionDispatchedSaveSnapshotsSuccess = this.actions$.pipe(ofActionDispatched(FlatActions.HistoryControlActions.SaveSnapshotsSuccess));

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  requestSetBlockUiType(blockUiType: FlatModels.EntityControlModels.BlockUiType) {
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(blockUiType));
  }

  requestUndoSnapshot() {
	  return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.undo)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.UndoSnapshot())
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError((result) => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
	  );
  }

  requestRedoSnapshot() {
	  return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.redo)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.RedoSnapshot())
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError((result) => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
	  );
  }

  requestSaveSnapshots() {
    return this.store.dispatch(new FlatActions.HistoryControlActions.SaveSnapshots());
  }

  //</editor-fold>
}
